import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { commonLabelConstants } from 'src/app/constants/LabelMessages';
@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})

export class PageNotFoundComponent {

  LabelConstant: any;

  constructor(private route: Router) { }

  ngOnInit() : void{
    this.LabelConstant = commonLabelConstants;
  }

  goToLogin() {
    this.route.navigate(['']);
  }
}